module.exports = __webpack_public_path__ + "static/media/chevron-circle-up.6b960cfc.svg";